import { render, staticRenderFns } from "./fenchaidui.vue?vue&type=template&id=547d2948&scoped=true"
import script from "./fenchaidui.vue?vue&type=script&lang=ts"
export * from "./fenchaidui.vue?vue&type=script&lang=ts"
import style0 from "./fenchaidui.vue?vue&type=style&index=0&id=547d2948&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547d2948",
  null
  
)

export default component.exports